<div class="PGFooter {{footerLarge ? 'PGFooter--Large' : ''}}">
    @if(!isSwitchingLanguage) {
        @if (!isHidden) {
            <div class="PGFooter-Links bg-white border-top">
                <div class="px-3">
                    <span class="PGFooter-Links-Item d-flex align-items-center me-2">
                        @if(footerLogo) {
                            <div class="me-1 PGFooter-Logo">
                                <img src="{{footerLogo}}" alt="">
                            </div>
                        }
                        @else {
                            @if (appLogo) {
                                <div class="me-1 PGFooter-Logo">
                                    <img src="{{appLogo}}" alt="">
                                </div>
                            }
                            @if (appProvider) {
                                <div>{{appProvider}}</div>
                            }
                            @if (!appProvider) {
                                <div class="small text-dark py-2 d-flex">
                                    <span>Powered by</span>
                                    @if (noLinks) {
                                        <span class="PGFooter-Links-Item text-dark d-flex ms-1">
                                            <img class="me-1 d-block PGFooter-Links-Item-Logo" src="assets/images/poistory.png" alt="">
                                            <b>Poistory</b>
                                        </span>
                                    }
                                    @if (!noLinks) {
                                        <a class="PGFooter-Links-Item text-dark d-flex ms-1" target="_blank" rel="noopener noreferrer" href="https://www.poistory.tech/">
                                            <img class="me-1 d-block PGFooter-Links-Item-Logo" src="assets/images/poistory.png" alt="">
                                            <b>Poistory</b>
                                            <span class="visually-hidden">{{ 'pg-cookie-consent.opens-new-window' | locTranslate }}</span>
                                        </a>
                                    }
                                </div>
                            }
                        }
    
                        @if(canInstall()) {
                            <span class="PGFooter-Links-Item--Install ms-2 PGTooltip"> 
                                <button type="button" class="PGFooter-Links-Item btn btn-sm btn-link" (click)="doInstall()"
                                    [attr.aria-label]="'pg-footer.install' | locTranslate">
                                    <i class="fa-regular fa-desktop-arrow-down" aria-hidden="true"></i>
                                </button>
                                <div class="PGTooltip-Content {{ installButtonShow ? 'd-block' : ''}}">{{ 'pg-footer.install' | locTranslate }}</div>
                            </span>
                        }
    
                        <span class="PGFooter-Links-Item--Version text-nowrap" ngbDropdown [autoClose]="'outside'">
                            <button class="btn {{ footerLarge ? '' : 'btn-sm' }} btn-link ms-2 p-0 text-muted" ngbDropdownToggle>
                                v {{getVersionString()}}
                            </button>
                            <div ngbDropdownMenu>
                                <div class="dropdown-item-text small" (click)="copyVersionsData()">
                                    <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                                        <div>
                                            <h6 class="m-0"><b>Versions</b></h6>
                                        </div>
                                        <div>
                                            <button class="btn btn-sm btn-link btn-white PGFooter-Links-Item-Button">
                                                <i class="fa-regular {{ copiedVersionsData ? 'fa-check text-success' : 'fa-copy'}}"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div [innerHTML]="getVersionsTable() | safe:'html'"></div>
                                </div>
                            </div>
                        </span>
                    </span>
    
                    <div class="PGFooter-Links-Inner d-flex justify-content-center {{ footerLarge ? '' : 'small' }}">
                        <div class="d-flex align-items-center">
                            @if (noLinks) {
                                <button type="button" class="PGFooter-Links-Item btn btn-link btn-sm p-0 text-muted" (click)="openModalText('privacy-policy')">{{ 'pg-footer.privacy-policy' | locTranslate }}</button>
                                <button type="button" class="PGFooter-Links-Item btn btn-link btn-sm p-0 text-muted" (click)="openModalText('terms-and-conditions')">{{ 'pg-footer.terms-and-conditions' | locTranslate }}</button>
                            }
                            @else {
                                <a class="PGFooter-Links-Item text-muted p-1" target="_blank" rel="noopener noreferrer" href="{{getPrivacyPolicyURL()}}">{{ 'pg-footer.privacy-policy' | locTranslate }}<span class="visually-hidden">{{ 'pg-cookie-consent.opens-new-window' | locTranslate }}</span></a>
                                <a class="PGFooter-Links-Item text-muted p-1" target="_blank" rel="noopener noreferrer" href="{{getTermsAndConditionsURL()}}">{{ 'pg-footer.terms-and-conditions' | locTranslate }}<span class="visually-hidden">{{ 'pg-cookie-consent.opens-new-window' | locTranslate }}</span></a>
                            }
                            @if (isCookieConsentAvailable()) {
                                <button type="button" class="PGFooter-Links-Item btn btn-link btn-sm p-0 text-muted" (click)="reviewCookies()">{{ 'pg-footer.review-cookies' | locTranslate }}</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        
        <div class="PGFooter-Messages border rounded bg-light px-3 py-2" [hidden]="!hasSomething()">
            <div [hidden]="!hasErrors()" class="mb-2">
                <app-pg-errors #errorsComponent></app-pg-errors>
            </div>
            @for (notification of notifications; track notification; let i = $index) {
                <div class="PGFooter-Notification {{i > 0 ? 'mt-3' : ''}} {{notification.duration != null ? 'pg-animation-fadeout' : ''}}"
                    [style.animationDelay]="(notification.duration - 200) + 'ms'" [style.animationDuration]="'200ms'">
                    <div class="PGFooter-Notification-Buttons">
                        @if (notification.duration == null || notification.duration > 5000) {
                            <button type="button" class="btn btn-sm btn-link text-dark p-1" (click)="removeNotification(notification)"
                                [attr.aria-label]="'forms-main.a11y.close' | locTranslate">
                                <i class="fa-regular fa-times" aria-hidden="true"></i>
                            </button>
                        }
                    </div>
                    <app-pg-notification [notification]="notification"></app-pg-notification>
                </div>
            }
        </div>
    }
</div>

<ng-template #modalText>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-footer.' + modalTextContent | locTranslate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModalText()"></button>
    </div>
    <div class="modal-body">
        <div [innerHTML]="'ENTOURANCE.' + modalTextContent | locTranslate"></div>
    </div>
</ng-template>